
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    text: {
      type: String,
      required: true,
    },
    invert: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["pressed"],
  computed: {
    styles(this) {
      return {
        "--bg-color":
          this.invert || this.disabled
            ? "rgb(228, 226, 220)"
            : "rgb(74, 83, 101)",
        "--text-color":
          this.invert || this.disabled
            ? "rgb(74, 83, 101)"
            : "rgb(228, 226, 220)",
        "--length": this.invert ? "13rem" : "18rem",
      };
    },
  },
  methods: {
    onclick(): void {
      if (!this.disabled) this.$emit("pressed");
    },
  },
});
